<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              v-on:click="setActiveTab"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>

      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="4">
                  <b-form-group
                    label="Escolha o tipo da conta"
                    label-for="tipo"
                  >
                    <select
                      name="tipo"
                      id="tipo"
                      v-model="form.tipo"
                      class="form-control"
                    >
                      <option
                        v-for="(t, index) in tipos"
                        :value="t.type"
                        :key="'code' + index"
                      >
                        {{ t.description }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group id="nome" label-for="nome" label="Nome">
                    <b-form-input
                      maxlength="20"
                      v-model="$v.form.nome.$model"
                      :state="validateState('nome')"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Escolha o banco" label-for="banco">
                    <VueSelect
                      id="banco"
                      ref="banco"
                      :filterable="false"
                      @input="setBanco"
                      :options="bancos"
                      v-model="bancoSelected"
                      placeholder="Informe o código do banco para filtrar"
                      @search="onSearchBancos"
                      :class="{
                        hasErrorsAcvtivity: !bancoFilled,
                        inputFilledBanco: bancoFilled,
                      }"
                    >
                      <template slot="no-options">
                        Informe o código do banco
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </VueSelect>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                    id="agencia"
                    label-for="agencia"
                    label="Agência"
                  >
                    <b-form-input
                      maxlength="4"
                      v-model="$v.form.agencia.$model"
                      :state="validateState('agencia')"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group id="conta" label-for="conta" label="Conta">
                    <b-form-input
                      maxlength="10"
                      v-model="$v.form.conta.$model"
                      :state="validateState('conta')"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group
                    id="beneficiario"
                    label-for="beneficiario"
                    label="Nome do Benificiário"
                  >
                    <b-form-input
                      v-model="$v.form.beneficiario.$model"
                      :state="validateState('beneficiario')"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group id="saldo" label-for="prsaldoeco" label="Saldo">
                    <money
                      class="form-control"
                      v-model="form.saldo"
                      v-bind="configMoney"
                    >
                    </money>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-if="mostrarSecaoSicoob" class="mt-4">
                <b-col md="12">
                  <div class="card border border-primary sicoob-section">
                    <div
                      class="card-header d-flex align-items-center justify-content-between"
                      style="cursor: pointer"
                      @click="sicoobCollapsed = !sicoobCollapsed"
                    >
                      <h5 class="mb-0 font-weight-bolder text-primary">
                        Integração Sicoob API
                      </h5>
                      <div class="d-flex align-items-center">
                        <b-badge
                          v-if="form.integracao_api"
                          variant="danger"
                          class="mr-3"
                        >
                          Produção
                        </b-badge>
                        <b-icon
                          :icon="
                            sicoobCollapsed ? 'chevron-down' : 'chevron-up'
                          "
                        />
                      </div>
                    </div>

                    <b-collapse :visible="!sicoobCollapsed">
                      <div class="card-body">
                        <!-- Indicador de certificado digital -->
                        <b-alert
                          show
                          :variant="
                            certificadoDisponivel ? 'success' : 'warning'
                          "
                          class="d-flex align-items-center"
                        >
                          <b-icon
                            :icon="
                              certificadoDisponivel
                                ? 'shield-check'
                                : 'shield-exclamation'
                            "
                            class="mr-2"
                            font-scale="1.4"
                          />
                          <div>
                            <strong>Certificado digital da empresa:</strong>
                            <b-badge
                              :variant="
                                certificadoDisponivel ? 'success' : 'danger'
                              "
                              class="ml-2"
                            >
                              {{
                                certificadoDisponivel
                                  ? "Encontrado"
                                  : "Não encontrado"
                              }}
                            </b-badge>
                            <div
                              v-if="!certificadoDisponivel"
                              class="mt-1"
                              style="font-size: 0.85rem"
                            >
                              Para usar a API Sicoob, cadastre primeiro o
                              certificado digital no emitente da empresa.
                            </div>
                          </div>
                        </b-alert>

                        <b-row>
                          <b-col md="4">
                            <b-form-group
                              label="Usar integração por API"
                              label-for="integracao_api"
                            >
                              <b-form-checkbox
                                id="integracao_api"
                                v-model="form.integracao_api"
                                switch
                                size="lg"
                              >
                                {{
                                  form.integracao_api ? "Ativada" : "Desativada"
                                }}
                              </b-form-checkbox>
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              label="Client ID Sicoob"
                              label-for="client_id"
                            >
                              <b-form-input
                                id="client_id"
                                v-model="form.client_id"
                                :disabled="!form.integracao_api"
                                autocomplete="off"
                              />
                              <small class="text-muted d-block mt-1">
                                Confirme o Client ID Sicoob e o Número do
                                cliente com a gerência da sua conta Sicoob.
                              </small>
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              label="Número do cliente Sicoob"
                              label-for="numero_contrato"
                            >
                              <b-form-input
                                id="numero_contrato"
                                v-model="form.numero_contrato"
                                :disabled="!form.integracao_api"
                                autocomplete="off"
                              />
                              <small class="text-muted d-block mt-1">
                                Também pode ser chamado de número do
                                contrato/cliente na documentação Sicoob.
                              </small>
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              label="Chave Pix"
                              label-for="chave_pix"
                            >
                              <b-form-input
                                id="chave_pix"
                                v-model="form.chave_pix"
                                :disabled="!form.integracao_api"
                                autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              label="Conta Corrente"
                              label-for="conta_sicoob"
                            >
                              <b-form-input
                                id="conta_sicoob"
                                v-model="form.conta"
                                :disabled="!form.integracao_api"
                                autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              label="Agência / Cooperativa"
                              label-for="agencia_sicoob"
                            >
                              <b-form-input
                                id="agencia_sicoob"
                                v-model="form.agencia"
                                :disabled="!form.integracao_api"
                                autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              label="Status da API"
                              label-for="status_api"
                            >
                              <b-form-input
                                id="status_api"
                                :value="form.status_api || 'Não informado'"
                                disabled
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <hr class="my-4" />
                        <h6 class="font-weight-bolder text-primary mb-3">
                          Configurações de cobrança
                        </h6>

                        <b-row>
                          <b-col md="4">
                            <b-form-group
                              label="Tipo de multa"
                              label-for="tipo_multa"
                            >
                              <b-form-select
                                id="tipo_multa"
                                v-model="form.tipo_multa"
                              >
                                <b-form-select-option value="0">
                                  0 - Isento
                                </b-form-select-option>
                                <b-form-select-option value="1">
                                  1 - Valor fixo
                                </b-form-select-option>
                                <b-form-select-option value="2">
                                  2 - Percentual
                                </b-form-select-option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              label="Dias para multa"
                              label-for="dias_multa"
                            >
                              <b-form-input
                                id="dias_multa"
                                v-model.number="form.dias_multa"
                                :disabled="multaIsenta"
                                type="number"
                                min="0"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              :label="multaValorLabel"
                              label-for="valor_multa"
                            >
                              <money
                                id="valor_multa"
                                class="form-control"
                                v-model="form.valor_multa"
                                v-bind="configMoney"
                                :disabled="multaIsenta"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <b-form-group
                              label="Tipo de juros"
                              label-for="tipo_juros_mora"
                            >
                              <b-form-select
                                id="tipo_juros_mora"
                                v-model="form.tipo_juros_mora"
                              >
                                <b-form-select-option value="1">
                                  1 - Valor por dia
                                </b-form-select-option>
                                <b-form-select-option value="2">
                                  2 - Taxa mensal
                                </b-form-select-option>
                                <b-form-select-option value="3">
                                  3 - Isento
                                </b-form-select-option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              label="Dias para juros"
                              label-for="dias_juros_mora"
                            >
                              <b-form-input
                                id="dias_juros_mora"
                                v-model.number="form.dias_juros_mora"
                                :disabled="jurosIsento"
                                type="number"
                                min="0"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col md="4">
                            <b-form-group
                              :label="jurosValorLabel"
                              label-for="valor_juros_mora"
                            >
                              <money
                                id="valor_juros_mora"
                                class="form-control"
                                v-model="form.valor_juros_mora"
                                v-bind="configMoney"
                                :disabled="jurosIsento"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <b-form-group
                              label="Dias limite para pagamento"
                              label-for="dias_limite_pagamento"
                            >
                              <b-form-input
                                id="dias_limite_pagamento"
                                v-model.number="form.dias_limite_pagamento"
                                type="number"
                                min="0"
                              />
                              <small class="text-muted d-block mt-1">
                                Quantidade de dias após o vencimento em que o
                                boleto ainda poderá ser pago.
                              </small>
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <hr class="my-4" />
                        <h6 class="font-weight-bolder text-primary mb-3">
                          Mensagens de instrução do boleto
                        </h6>
                        <small class="text-muted d-block mb-3">
                          O Sicoob permite até 5 mensagens, com no máximo 40
                          caracteres cada.
                        </small>

                        <b-row>
                          <b-col
                            md="6"
                            v-for="index in 5"
                            :key="`mensagem_instrucao_${index}`"
                          >
                            <b-form-group
                              :label="`Mensagem ${index}`"
                              :label-for="`mensagem_instrucao_${index}`"
                            >
                              <b-form-input
                                :id="`mensagem_instrucao_${index}`"
                                v-model="form[`mensagem_instrucao_${index}`]"
                                maxlength="40"
                                autocomplete="off"
                              />
                              <small class="text-muted d-block text-right">
                                {{ mensagemLength(index) }}/40
                              </small>
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <div class="d-flex justify-content-end">
                          <button
                            type="button"
                            ref="testar_conexao_sicoob"
                            class="btn btn-outline-primary font-weight-bold"
                            :disabled="
                              !form.integracao_api ||
                              !form.id_banco ||
                              testandoConexao
                            "
                            @click="testarConexaoSicoob"
                          >
                            <b-spinner small v-if="testandoConexao" />
                            <span v-else>Testar conexão Sicoob</span>
                          </button>
                        </div>
                        <small
                          v-if="!form.id_banco"
                          class="text-muted d-block text-right mt-1"
                        >
                          Salve a conta bancária para liberar o teste de
                          conexão.
                        </small>
                      </div>
                    </b-collapse>
                  </div>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_novo_banco"
                class="btn btn-primary font-weight-bold"
              >
                Salvar
              </button>
              <router-link
                class="btn btn-clean font-weight-bold"
                :to="{
                  name: 'bancosLista',
                }"
              >
                Cancelar
              </router-link>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import bancosData, { BancosDataRequired } from "./BancosData";
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import { MONEY as settingMoney } from "@/modules/Application";
import { Money } from "v-money";
import _ from "lodash";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  getStatusSicoob,
  testarConexaoSicoob,
} from "@/core/services/sicoob.service";

export default {
  name: "app-bancos-form",
  props: {
    url: {
      type: String,
    },
    banco: {
      type: Object,
      default: () => {},
    },
  },
  directives: {
    mask,
  },
  components: {
    Money,
    VueSelect,
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      bancos: [],
      configMoney: settingMoney,
      tipos: [
        {
          type: "savings",
          description: "Conta Poupança",
        },
        {
          type: "checking",
          description: "Conta Corrente",
        },
      ],
      bancoFilled: false,
      bancoSelected: null,
      sicoobCollapsed: false,
      certificadoDisponivel: false,
      testandoConexao: false,
    };
  },
  watch: {
    banco(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
        this.applySicoobDefaults();
        this.bancos = newValue.banco_zoop ?? null;
      }
    },
    mostrarSecaoSicoob(isVisible) {
      if (isVisible && this.form && this.form.id_banco) {
        this.carregarStatusSicoob();
      }
    },
  },
  validations: {
    form: BancosDataRequired,
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
    mostrarSecaoSicoob() {
      const code = String(
        this.bancoSelected?.code || this.form?.banco || ""
      ).replace(/^0+/, "");
      const name = String(this.bancoSelected?.name || "").toLowerCase();
      return (
        this.form?.integracao_api === true ||
        code === "756" ||
        name.includes("sicoob")
      );
    },
    multaIsenta() {
      return String(this.form?.tipo_multa ?? "0") === "0";
    },
    jurosIsento() {
      return String(this.form?.tipo_juros_mora ?? "3") === "3";
    },
    multaValorLabel() {
      return String(this.form?.tipo_multa ?? "0") === "2"
        ? "Percentual da multa (%)"
        : "Valor da multa (R$)";
    },
    jurosValorLabel() {
      return String(this.form?.tipo_juros_mora ?? "3") === "2"
        ? "Taxa de juros mensal (%)"
        : "Valor do juros por dia (R$)";
    },
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  methods: {
    async setBanco(banco) {
      this.bancoSelected = banco;
      this.bancoFilled = true;
    },
    async getDataInit() {
      this.form = new bancosData({});
      this.applySicoobDefaults();
      if (this.banco.id_banco) {
        this.form = this.banco;
        this.applySicoobDefaults();
        this.setBanco(this.banco.banco_zoop);
        if (this.mostrarSecaoSicoob) {
          this.carregarStatusSicoob();
        }
        return;
      }
    },
    applySicoobDefaults() {
      this.form.tipo_multa =
        this.form.tipo_multa === undefined || this.form.tipo_multa === null
          ? "0"
          : String(this.form.tipo_multa);
      this.form.dias_multa =
        this.form.dias_multa === undefined || this.form.dias_multa === null
          ? ""
          : this.form.dias_multa;
      this.form.valor_multa =
        this.form.valor_multa === undefined || this.form.valor_multa === null
          ? ""
          : this.form.valor_multa;
      this.form.tipo_juros_mora =
        this.form.tipo_juros_mora === undefined ||
        this.form.tipo_juros_mora === null
          ? "3"
          : String(this.form.tipo_juros_mora);
      this.form.dias_juros_mora =
        this.form.dias_juros_mora === undefined ||
        this.form.dias_juros_mora === null
          ? ""
          : this.form.dias_juros_mora;
      this.form.valor_juros_mora =
        this.form.valor_juros_mora === undefined ||
        this.form.valor_juros_mora === null
          ? ""
          : this.form.valor_juros_mora;
      this.form.dias_limite_pagamento =
        this.form.dias_limite_pagamento === undefined ||
        this.form.dias_limite_pagamento === null ||
        this.form.dias_limite_pagamento === ""
          ? 30
          : Number(this.form.dias_limite_pagamento);
      for (let index = 1; index <= 5; index++) {
        const field = `mensagem_instrucao_${index}`;
        this.form[field] = this.form[field] || "";
      }
    },
    mensagemLength(index) {
      return String(this.form[`mensagem_instrucao_${index}`] || "").length;
    },
    parseNumber(value) {
      if (value === undefined || value === null || value === "") return 0;
      if (typeof value === "number") return value;
      const normalized = String(value).replace(/\./g, "").replace(",", ".");
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    validarCobrancaSicoob() {
      if (!this.mostrarSecaoSicoob) return true;

      if (
        String(this.form.tipo_multa) !== "0" &&
        (Number(this.form.dias_multa) <= 0 ||
          this.parseNumber(this.form.valor_multa) <= 0)
      ) {
        this.$toast.error(
          "Para multa, informe dias e valor maiores que zero."
        );
        return false;
      }

      if (
        String(this.form.tipo_juros_mora) !== "3" &&
        (Number(this.form.dias_juros_mora) <= 0 ||
          this.parseNumber(this.form.valor_juros_mora) <= 0)
      ) {
        this.$toast.error(
          "Para juros, informe dias e valor maiores que zero."
        );
        return false;
      }

      this.form.dias_limite_pagamento =
        this.form.dias_limite_pagamento === undefined ||
        this.form.dias_limite_pagamento === null ||
        this.form.dias_limite_pagamento === ""
          ? 30
          : Number(this.form.dias_limite_pagamento);

      const diasMulta =
        String(this.form.tipo_multa) === "0" ? 0 : Number(this.form.dias_multa);
      const diasJuros =
        String(this.form.tipo_juros_mora) === "3"
          ? 0
          : Number(this.form.dias_juros_mora);

      if (
        Number(this.form.dias_limite_pagamento) < diasMulta ||
        Number(this.form.dias_limite_pagamento) < diasJuros
      ) {
        this.$toast.error(
          "Dias limite para pagamento deve ser maior ou igual aos dias de multa e juros."
        );
        return false;
      }

      for (let index = 1; index <= 5; index++) {
        const field = `mensagem_instrucao_${index}`;
        if (String(this.form[field] || "").length > 40) {
          this.$toast.error(
            "Cada mensagem de instrução deve ter no máximo 40 caracteres."
          );
          return false;
        }
      }

      return true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActivePreviousTab() {
      this.tabIndex = parseInt(localStorage.getItem("builderTab")) || 0;
      const links = this.$refs["builder-tab"].querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.$refs["builder-tab"]
        .querySelector(`[data-tab="${this.tabIndex}"]`)
        .classList.add("active");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_novo_banco"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        if (!this.validarCobrancaSicoob()) {
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        if (this.bancoSelected) {
          this.form.banco = this.bancoSelected.code;
          this.form.id_banco_zoop = this.bancoSelected.id_banco_zoop;
        }

        this.form.ambiente_api = "producao";
        this.applySicoobDefaults();

        await this.$http.post(this.url, {
          ...this.form,
          ambiente_api: "producao",
        });

        this.$router.push({ name: "bancosLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }
    },
    onSearchBancos(search, loading) {
      if (search.length) {
        loading(true);
        this.searchBanco(loading, search, this);
      }
    },
    searchBanco: _.debounce(async (loading, search, vm) => {
      vm.bancos = await vm.getBancoZoopByCode(search);
      loading(false);
    }, 350),
    async carregarStatusSicoob() {
      if (!this.form?.id_banco) return;
      try {
        const { data } = await getStatusSicoob(this.form.id_banco);
        this.certificadoDisponivel = Boolean(data?.certificado_disponivel);
        this.form.status_api = data?.status_api || this.form.status_api || "";
      } catch (error) {
        this.certificadoDisponivel = false;
        this.form.status_api = this.form.status_api || "";
      }
    },
    async testarConexaoSicoob() {
      if (this.testandoConexao || !this.form?.id_banco) return;
      this.testandoConexao = true;
      try {
        await testarConexaoSicoob(this.form.id_banco);
        this.certificadoDisponivel = true;
        this.$toast.success("Conexão com Sicoob realizada com sucesso.");
      } catch (error) {
        const payload = error?.response?.data || {};
        const tipo = String(
          payload?.error || payload?.type || ""
        ).toLowerCase();
        if (
          tipo.includes("certificado") ||
          payload?.certificado_disponivel === false
        ) {
          this.certificadoDisponivel = false;
          this.$toast.error(
            "Empresa não possui certificado digital cadastrado. Cadastre o certificado no emitente antes de ativar a integração Sicoob."
          );
        } else {
          this.$toast.error(
            payload?.msg ||
              payload?.message ||
              "Não foi possível conectar ao Sicoob. Verifique as credenciais."
          );
        }
      } finally {
        this.testandoConexao = false;
      }
    },
  },
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
  color: black;
}

.hasErrorsAcvtivity .vs__dropdown-toggle {
  border: 2px solid red;
  /* color: #394066; */
}

.vs__dropdown-menu {
  color: black !important;
}

.hasErrorsAcvtivity .vs__clear,
.hasErrorsAcvtivity .vs__open-indicator {
  fill: red;
}

.inputFilledBanco .vs__dropdown-toggle {
  border: 2px solid #1bc5bd;
  /* color: #394066; */
}

.inputFilledBanco .vs__clear,
.inputFilledBanco .vs__open-indicator {
  fill: #1bc5bd;
}

.inputFilledTipo .vs__dropdown-toggle {
  border: 2px solid #1bc5bd;
  /* color: #394066; */
}

.inputFilledTipo .vs__clear,
.inputFilledTipo .vs__open-indicator {
  fill: #1bc5bd;
}

.inputFilled {
  border: 2px solid #1bc5bd !important;
}
</style>
